/**
 * Breakpoint constants matching NCIDS/USWDS design system
 * These values define the minimum width for each breakpoint
 *
 * Reference: https://designsystem.digital.gov/utilities/layout-grid/
 */
export const BREAKPOINTS = {
	MOBILE: 0,
	MOBILE_LG: 480,
	TABLET: 640,
	TABLET_LG: 880,
	DESKTOP: 1024,
	DESKTOP_LG: 1200,
	WIDESCREEN: 1400,
};
